import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-wrapper" }
const _hoisted_2 = ["src", "poster"]
const _hoisted_3 = { class: "video-overlay" }
const _hoisted_4 = ["src"]

import { ref, nextTick, computed, watch } from 'vue'
import { FullscreenOutlined } from '@ant-design/icons-vue'
import { useVideo } from '@/composables/useVideo'
import { useInlineAutoplayVideo } from '@/composables/useInlineAutoplayVideo'

interface Props {
  src: string
  poster?: string
  coverScale?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoPlayer',
  props: {
    src: {},
    poster: {},
    coverScale: {}
  },
  setup(__props: any) {

const noop = () => undefined

const props = __props

const videoRef = ref<HTMLVideoElement | null>(null)
const modalVideoRef = ref<HTMLVideoElement | null>(null)
const { handleVideoPlay, handleVideoPause } = useVideo()

const hover = ref(false)
const isModalOpen = ref(false)

let activeAudio: HTMLVideoElement | null = null

const ensureExclusiveAudio = (video: HTMLVideoElement | null) => {
  if (activeAudio && activeAudio !== video) {
    activeAudio.pause()
    activeAudio.currentTime = 0
  }
  activeAudio = video
}

const clearActiveAudio = (video: HTMLVideoElement | null) => {
  if (activeAudio === video) {
    activeAudio = null
  }
}

const videoStyle = computed(() => {
  if (props.coverScale && props.coverScale !== 1) {
    return {
      transform: `scale(${props.coverScale})`,
      transformOrigin: 'center center'
    }
  }
  return {}
})

const { configureVideo, pauseInlineVideo, requestAutoplay } = useInlineAutoplayVideo(videoRef, {
  isEnabled: () => !isModalOpen.value,
  pauseWhenOutOfView: true
})

// Looping is handled via the `loop` attribute; no manual ended handling is required.

const openModal = () => {
  hover.value = false
  pauseInlineVideo()
  isModalOpen.value = true
  nextTick(() => {
    if (modalVideoRef.value) {
      modalVideoRef.value.muted = false
      modalVideoRef.value.currentTime = 0
      modalVideoRef.value.play().then(() => {
        ensureExclusiveAudio(modalVideoRef.value)
      }).catch(noop)
    }
  })
}

const stopModalAudio = () => {
  if (modalVideoRef.value) {
    modalVideoRef.value.pause()
    modalVideoRef.value.currentTime = 0
    modalVideoRef.value.muted = true
    clearActiveAudio(modalVideoRef.value)
  }
}

const resumeInlineMuted = () => {
  configureVideo()
  requestAutoplay()
}

const handleModalCancel = () => {
  stopModalAudio()
}

const handleModalClose = () => {
  stopModalAudio()
  resumeInlineMuted()
}

watch(isModalOpen, (open) => {
  if (!open) {
    stopModalAudio()
    resumeInlineMuted()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "video-container",
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (hover.value = true)),
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hover.value = false))
    }, [
      _createElementVNode("video", {
        ref_key: "videoRef",
        ref: videoRef,
        class: "video-element",
        src: __props.src,
        poster: __props.poster,
        autoplay: "",
        preload: "metadata",
        playsinline: "",
        "webkit-playsinline": "true",
        "x5-playsinline": "true",
        "x5-video-player-type": "h5",
        "x5-video-player-fullscreen": "false",
        muted: "",
        loop: "",
        style: _normalizeStyle(videoStyle.value),
        onPlay: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleVideoPlay) && _unref(handleVideoPlay)(...args))),
        onPause: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleVideoPause) && _unref(handleVideoPause)(...args)))
      }, " Your browser does not support the video tag. ", 44, _hoisted_2),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "overlay-expand",
          onClick: _withModifiers(openModal, ["stop"])
        }, [
          _createVNode(_unref(FullscreenOutlined), { class: "expand-icon" })
        ])
      ], 512), [
        [_vShow, hover.value]
      ])
    ], 32),
    _createVNode(_component_a_modal, {
      open: isModalOpen.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((isModalOpen).value = $event)),
      footer: null,
      centered: "",
      width: '90%',
      style: { maxWidth: '1400px' },
      "wrap-class-name": "video-modal",
      onAfterClose: handleModalClose,
      onCancel: handleModalCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          ref_key: "modalVideoRef",
          ref: modalVideoRef,
          class: "modal-video",
          src: __props.src,
          playsinline: "",
          "webkit-playsinline": "true",
          controls: "",
          autoplay: ""
        }, " Your browser does not support the video tag. ", 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})